<script setup lang="ts">
  import MainHeader from '../layouts/Header/HeaderLayout.vue'
  import MainFooter from '../layouts/Footer/Footer.vue'
  import ModalSubscribePlans from '../../components/Modais/ModalSubscribePlansAndCredits.vue'
  import ModalMessages from '../../components/Modais/ModalMessages.vue'
  import ModalSubscribeExit from '../../components/Modais/ModalSubscribeExit.vue'
  import ModalPromotionPopup from '../../components/Modais/ModalPromotionPopup.vue'
  import ModalAcceptCookies from '../../components/Modais/ModalAcceptCookies.vue'
  import ModalNewsletter from '../../components/Modais/ModalNewsletter.vue'
  import MetaTags from './MetaTags.vue'
  import ModalLegalWarning from '../../components/Modais/ModalLegalWarning.vue'
  import ModalNotification from '../../components/Modais/ModalNotification.vue'
  import ModalBannerPlanUnique from '../../components/Modais/ModalBannerPlanUnique.vue'
  import IconeBds from 'assets/img/icone_BDS.png'
  import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from 'vue'

  import modelTradutor from '../../tradutors/model'
  import { notificationStore } from '../../stores/notification'
  import { localeStore } from '../../stores/locale'
  import { planStore } from '../../stores/plans'
  import { subscribeExitStore } from '../../stores/subscribeExit'

  import { userStore } from '../../stores/user'
  import api from '../../api'
  import { detectIncognito } from 'detectincognitojs'
  import { planCreditStore } from '../../stores/planscredits'
  import { useRoute } from 'vue-router'
  import { useCookies } from 'vue3-cookies'

  const { cookies } = useCookies()
  const storeLocale = localeStore()
  const storePlan = planStore()
  const storeUser = userStore()
  const storePlanCredit = planCreditStore()
  const storeSubscribeExit = subscribeExitStore()
  const storeNotification = notificationStore()
  const route = useRoute()

  const optionsPlanUnique = ref({
    showFooter: false,
    image: ''
  })

  const windowWidth = ref('0px')
  const windowHeight = ref('0px')
  const isOpenMenu = ref(false)
  const showSubscribe = ref(false)
  const options = ref({
    showModal: false,
    titleModal: '',
    textBodyModal: '',
    textButtonModal: '',
    routerName: '',
    presente: false,
  })
  const optionsSubsExit = ref({
    showModal: false,
    html: ''
  })
  const promotions = ref({})
  const newsletter = ref({})
  const showModalCookies = ref(false)
  const optionsNotifications = ref({
    showModal1: false,
    showModal2: false,
    showModal3: false,
    showBell: false
  })

  const reactiveLocale = computed(() => storeLocale.locale)
  const reactiveisActiveUser = computed(() => storeUser.isActiveUser)
  const reactiveVoucher = computed(() => storePlan.voucher)
  const reactiveCoupon = computed(() => storePlan.coupon)  
  
  const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return modelTradutor.portugues
    } else {
      return modelTradutor.ingles
    }
  })

  watch(reactiveLocale, () => {
    getPlans()
    getPlansCredits()
  })

  watch(reactiveVoucher, () => {
    storePlan.setCloseBanner(false)
    getBannerPlanUnique()
  })

  onBeforeMount(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    if (
      reactiveLocale.value !== storePlan.languagePlans ||
      route.query.coupon ||
      route.query.voucher ||
      !storePlan.plans
    )
      getPlans()
    registerSubscribeExitLocalStorage()
    if (
      storeUser.isActiveUser == false &&
      route.name != 'AssineOptionsPage' &&
      route.name != 'AssineAccountPage' &&
      route.name != 'AssinePaymentPage'
    ) {
      getModalsPromotionPopup()
      getModalSubscribeExit(false)      
      getModalNewsletter()      
    }

    if (
      reactiveLocale.value !== storePlanCredit.languagePlansCredits ||
      !storePlanCredit.plansCredits || reactiveVoucher.value || 
      route.query.coupon
    )
      getPlansCredits()
    storeUser.getActiveUser()
  })

  onMounted(() => {
    getAffiliates()
    setInterval(() => {
      if (document.getElementById('modalLegalWarning') == null &&
          route.name != 'AssineOptionsPage' &&
          route.name != 'AssineAccountPage' &&
          route.name != 'AssinePaymentPage'      
      ) {
        showModalCookies.value = true
      }
    }, 5000)
    setTimeout(() => {
      userNotification()
    }, 100)
    getBannerPlanUnique()

    if (storeUser.user && storeUser.user.email) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'user_id',
        user_id: {
          email: storeUser.user.email
        }
      })
    }
  })

  function getAffiliates() {
    let paramUrl =
      route.params.locale != 'pt-br' && route.params.locale != 'en' ? route.params.locale : ''
    if (route.query.cp || route.query.partner || paramUrl) {
      api
        .get('v1/checkAffiliates', { params: { url: paramUrl, ...route.query } })
        .then(({ data: { redirect } }) => {
          if (redirect) window.location.replace(redirect)
        })
    }
  }

  function getPlansCredits() {
    api
      .get(
        `v1/home/getPlansCredits?language=${reactiveLocale.value ?? ''}&coupon=${
          route.query.coupon || reactiveCoupon.value || ''
        }`
      )
      .then(({ data }) => {
        storePlanCredit.setPlanCredits(data.plans)
      })
  }

  async function getModalsPromotionPopup() {
    api
      .get(`v1/promotions/getActivePromotions?locale=${reactiveLocale.value ?? ''}`)
      .then(({ data }) => {
        if (data.length) {
          promotions.value = data
          if (!cookies.isKey('bellaPromoShow')) {
            cookies.set('bellaPromoShow', '1', 1000 * 60 * 60 * 24)
          }
          if (!cookies.isKey('countAccessPromotion')) {
            cookies.set('countAccessPromotion', '0', 1000 * 60 * 60 * 24 * 7)
          }
        } else {
          cookies.remove('bellaPromoShow')
          cookies.remove('countAccessPromotion')
          cookies.remove('showFooterPromoBanner')
        }
      })
  }

  async function getModalNewsletter() {
    api.get(`v1/newsletter/getActiveNewsletterApi`).then(({ data }) => {
      newsletter.value = data
    })
  }

  async function getModalSubscribeExit(forceShowModal) {
    var params = storeSubscribeExit.bellaSubscribeExit
    if (params.count) {
      let requestOptions = {
        first_date:
          params.first_time_date.year +
          '-' +
          params.first_time_date.month +
          '-' +
          params.first_time_date.day,
        count: params.count,
        has_showed: params.has_showed,
        language: reactiveLocale.value,
        newfront: true
      }
      api.post('modal/show/exit-subscribe', requestOptions).then(({ data }) => {
        if (typeof data === 'object') {
          data.canShowModal = forceShowModal || data.canShowModal || false
          let canShowModal = data.canShowModal
          // mostra o modal se regra foi atendida e se ainda não foi mostrado E se não estiver na página do assine
          if (
            canShowModal &&
            params.has_showed === 'false' &&
            (params.last_page !== route.name || forceShowModal)
          ) {
            if (document.getElementById('modalPromoMain') == null &&
                document.getElementById('modalPromoFooter') == null &&
                document.getElementById('modalSubscribeExit') == null &&
                document.getElementById('modalLegalWarning') == null &&
                document.getElementById('modalBannerPlanUnique') == null &&                     
                document.getElementById('modalNotification') == null && 
                document.getElementById('modalLgpdAccept') == null && 
                document.getElementById('modalNewsletter') == null
              ) {

              var html = data.html.replace(/#close-modal-promo/g, '')
              optionsSubsExit.value.html = html
              optionsSubsExit.value.showModal = true
              params.has_showed = 'true'
              storeSubscribeExit.setSubscribeParams(params)

              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'paywall',
                paywall: {
                  acionador: 'ModalSubscribeExit'
                }
              })
            }
          }
        }
      })
    }
  }

  function registerSubscribeExitLocalStorage() {
    if (typeof localStorage === 'object' && route.name == 'AssineOptionsPage') {
      var params
      if (!storeSubscribeExit.bellaSubscribeExit.count) {
        params = {
          last_page: route.name,
          first_time_date: getJsonDate(),
          count: 1,
          has_showed: 'false'
        }
      } else {
        // incrementa a contagem
        params = storeSubscribeExit.bellaSubscribeExit
        params.count++
        params.has_showed = 'false'
      }
      storeSubscribeExit.setSubscribeParams(params)
    }
  }
  function getJsonDate() {
    var dateObj = new Date()
    var month = dateObj.getUTCMonth() + 1 //months from 1-12
    var day = dateObj.getUTCDate()
    var year = dateObj.getUTCFullYear()
    return {
      day: day,
      month: month,
      year: year
    }
  }
  function handleResize() {
    windowWidth.value = `${window.innerWidth}px`
    windowHeight.value = `${window.innerHeight}px`
  }

  async function getBannerPlanUnique() {
    if (
      reactiveVoucher.value != '' &&
      storePlan.closeBannerPlanUnique == false &&
      reactiveisActiveUser.value == false
    ) {
      api
        .get(`v1/promotions/getBannerPlanUnique?locale=${reactiveLocale.value ?? ''}`)
        .then(({ data }) => {
          if (
            data != '' &&
            document.getElementById('modalPromoMain') == null &&
            document.getElementById('modalPromoFooter') == null &&
            document.getElementById('modalSubscribeExit') == null &&
            document.getElementById('modalLgpdAccept') == null &&
            document.getElementById('modalLegalWarning') == null &&
            document.getElementById('modalNewsletter') == null
          ) {
            if (
              route.name != 'AssineOptionsPage' &&
              route.name != 'AssineAccountPage' &&
              route.name != 'AssinePaymentPage'
            )
              optionsPlanUnique.value.showFooter = true
            optionsPlanUnique.value.image = data
          }
        })
    }
  }

  function getPlans() {
    const voucher = route.query.coupon ? '' : (route.query.voucher || reactiveVoucher.value || '')
    const coupon = route.query.voucher ? '' : (route.query.coupon || reactiveCoupon.value || '')
    api
      .get(
        `v1/home/getPlansFreeTour?language=${reactiveLocale.value ?? ''}&coupon=${coupon}&voucher=${voucher}`
      )
      .then(({ data }) => {
        storePlan.setPlans(data.plansFreeTour)
        storePlan.setCoupon(coupon)
        storePlan.setCloseBanner(false)
        storePlan.setVoucher(voucher)
        storePlan.setCardOnlyPromotion(data.cardOnlyPromotion ?? false)
      })
  }
  function closeNotification() {
    optionsNotifications.value.showModal1 = false
  }
  function closeNotificationCheckBar() {
    optionsNotifications.value.showModal2 = false
  }
  function subscribeShowPrompt() {
    closeNotification()
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        addServiceWorkerAndRegister(true)
        optionsNotifications.value.showModal2 = false
      }
    })
    setTimeout(() => {
      if (Notification.permission == 'default' && !detectmob()) {
        optionsNotifications.value.showModal2 = true
      }
    }, 2000)
  }

  async function userNotification() {
    if ('serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window) {
      let paramsNotification: any = new Object()
      if (!storeNotification.bellaNotifications.timer_show) {
        paramsNotification.first_time_date = new Date().getTime()
        paramsNotification.first_show = false
        await api.get('v1/notifications/getParameters').then(({ data }) => {
          paramsNotification.timer_show = data.notification_timer_show
          paramsNotification.days_next = data.notification_days_next
          paramsNotification.wp_key = data.notification_webpush_key
        })
        storeNotification.setNotificationsParams(paramsNotification)
      } else {
        paramsNotification = storeNotification.bellaNotifications
      }
      if (Notification.permission == 'default') {
        if (
          paramsNotification.first_show == false &&
          typeof paramsNotification.timer_show === 'string'
        ) {
          setTimeout(() => {
            showModalNotification()
            paramsNotification.first_show = true
            paramsNotification.first_time_date = new Date().getTime()
            storeNotification.setNotificationsParams(paramsNotification)
          }, parseInt(paramsNotification.timer_show) * 1000)
        } else {
          const daysNext = parseInt(paramsNotification.days_next) * 24 * 60 * 60 * 1000

          const diffNowFirst = new Date().getTime() - +paramsNotification.first_time_date
          if (diffNowFirst > daysNext) {
            setTimeout(() => {
              showModalNotification()
              paramsNotification.first_time_date = new Date().getTime()
              storeNotification.setNotificationsParams(paramsNotification)
            }, parseInt(paramsNotification.timer_show) * 1000)
          }
        }
      } else if (Notification.permission == 'granted') {
        addServiceWorkerAndRegister(false)
        storeNotification.resetNotificationsParams()
      } else if (Notification.permission == 'denied') {
        storeNotification.resetNotificationsParams()
      }
    }
    detectIncognito().then((result) => {
      if (
        Notification.permission != 'granted' &&
        result.isPrivate == false &&
        (window.location.protocol == 'https:' || window.location.hostname == 'localhost')
      ) {
        optionsNotifications.value.showBell = true
      }
    })
  }
  function showModalNotification() {
    detectIncognito().then((result) => {
      if (
        Notification.permission == 'default' &&
        result.isPrivate == false &&
        (window.location.protocol == 'https:' || window.location.hostname == 'localhost')
      ) {
        if (
          document.getElementById('modalLegalWarning') == null && //Modal 18+
          document.getElementById('modalLgpdAccept') == null && //Modal Aceite LGPD
          document.getElementById('modalNewsletter') == null
        ) {
          //Modal Newsletter
          optionsNotifications.value.showModal1 = true
        }
      }
    })
  }

  function addServiceWorkerAndRegister(showWelcome: boolean) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      if (registrations.length == 0) {
        navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
        subscribeRegister(showWelcome)
      } else {
        navigator.serviceWorker.ready.then((sw) => {
          sw.pushManager.getSubscription().then((subscription) => {
            if (subscription == null) {
              subscribeRegister(showWelcome)
            }
          })
        })
      }
    })
  }
  function subscribeRegister(showWelcome: boolean) {
    const paramsNotification = storeNotification.bellaNotifications
    navigator.serviceWorker.ready.then((sw) => {
      sw.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: atob(paramsNotification.wp_key)
        })
        .then((subscription) => {
          optionsNotifications.value.showBell = false
          const requestOptions = {
            data: JSON.stringify(subscription),
            locale: reactiveLocale.value ?? 'pt-br'
          }
          api.post('v1/notifications/savePushSubscriptionApi', requestOptions).then(({ data }) => {
            cookies.set('subscriptionId', data['subscriptionId'], 1000 * 60 * 60 * 24 * 365)
            storeNotification.resetNotificationsParams()
            closeNotification()
            if (showWelcome) sendNotificationWelcome()
          })
        })
    })
  }
  function sendNotificationWelcome() {
    if (reactiveLocale.value == 'en') {
      var notify_title = 'Welcome'
      var notify_body =
        "From now on, you'll stay up to date with all the news from Bella Club, through this notification window!"
    } else {
      var notify_title = 'Seja bem-vindo'
      var notify_body =
        'A partir de agora, você vai ficar por dentro de todas as novidades do Bella da Semana, através desta janela de notificações!'
    }
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(notify_title, {
        tag: 'tag-welcome',
        body: notify_body,
        icon: IconeBds,
        badge: IconeBds,
        requireInteraction: true
      })
    })
  }
  function checkNotificationStatus() {
    if (Notification.permission == 'default') {
      optionsNotifications.value.showModal1 = true
    } else {
      optionsNotifications.value.showModal3 = true
    }
  }
  function closeNotificationStatus() {
    optionsNotifications.value.showModal3 = false
  }
  function detectmob() {
    return !!(
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    )
  }

  function showModalSubscribeExit(data) {
    optionsSubsExit.value.showModal = data.message.show
  }

  function showMenuLateral(value) {
    isOpenMenu.value = value
  }
  function showModalSubscribePlans(val) {
    showSubscribe.value = val
  }
  function handleContextMenu(event) {
    if (route.path.includes('video')) event.preventDefault()
  }

  function showModalMessages(data) {
    options.value.showModal = data.message.show
    options.value.titleModal = data.message.title
    options.value.textBodyModal = data.message.textBoby
    options.value.textButtonModal = data.message.textButton
    options.value.routerName = data.message.routerName;
    options.value.presente = data.message.presente    
  }

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })
</script>
<template>
  <MetaTags />
  <div
    class="custom-container"
    :style="{ backgroundColor: '#000', width: windowWidth }"
    @contextmenu="handleContextMenu"
  >
    <MainHeader :show="isOpenMenu" @showMenuLateral="showMenuLateral" @showModalSubscribePlans="showModalSubscribePlans"/>

    <main>
      <slot :showModalMessages="showModalMessages" />
    </main>
    <ModalLegalWarning />
    <ModalMessages @showModalMessages="showModalMessages" :options="options" />
    <MainFooter v-if="true" @showModalMessages="showModalMessages" />
    <ModalSubscribePlans
      @showModalSubscribePlans="showModalSubscribePlans"
      :showSubscribe="showSubscribe"
      v-if="storePlan.plans"
      :plans="storePlan.plans"
      :translate="translate"
    />
    <ModalSubscribeExit
      :optionsSubsExit="optionsSubsExit"
      @showModalSubscribeExit="showModalSubscribeExit"
    />
    <ModalPromotionPopup
      v-for="(promotion, index) in promotions"
      :key="index"
      :optionsPromotionPopup="promotion"
    />
    <ModalNewsletter
      v-if="newsletter"
      :optionsNewsletter="newsletter"
      @showModalMessages="showModalMessages"
    />
    <ModalAcceptCookies v-if="showModalCookies" />
    <ModalNotification
      :optionsNotifications="optionsNotifications"
      @closeNotification="closeNotification"
      @subscribeShowPrompt="subscribeShowPrompt"
      @closeNotificationCheckBar="closeNotificationCheckBar"
      @checkNotificationStatus="checkNotificationStatus"
      @closeNotificationStatus="closeNotificationStatus"
    />
    <ModalBannerPlanUnique :optionsPlanUnique="optionsPlanUnique" />
  </div>
</template>

<style>
  #slot-post-api img {
    max-width: 100% !important;
  }

  #slot-post-api a {
    text-decoration: underline;
  }

  .custom-container {
    max-width: 1440px;
    margin: 0 auto;
    position: relative;
  }

  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .right-menu {
    position: absolute;
    background: whitesmoke;
    z-index: 110;
    display: none;
  }

  .show-menu {
    width: 25% !important;
    display: block;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .pagination-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 10px;
  }

  .paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
  }

  .paginate-buttons:hover {
    background-color: #d8d8d8;
  }

  .active-page {
    background-color: #b20000;
    border: 1px solid #b20000;
    color: white;
  }

  .active-page:hover {
    background-color: #b20000;
  }

  ul#componentContainer {
    display: flex !important;
    justify-content: center;
  }

  .l-header {
    position: sticky;
  }

  @media (max-width: 960px) {
    .right-menu {
      width: 0%;
    }
  }

  @media (max-width: 1500px) {
    .show-menu {
      width: 35% !important;
    }
  }

  @media (max-width: 1000px) {
    .show-menu {
      width: 50% !important;
    }
  }

  @media (max-width: 769px) {
    .show-menu {
      width: 60% !important;
    }
  }

  @media (max-width: 412px) {
    .show-menu {
      width: 80% !important;
    }
  }

</style>
